import type { PaymentPackage } from '@/hooks/api/usePayments';
import { formatPackagePrice } from '@/hooks/api/usePayments';
import { t } from '@/i18n';
import styles from './UnlimitedTariff.module.css';

interface UnlimitedTariffProps {
  package: PaymentPackage | null;
  onSelect?: () => void;
  selected?: boolean;
}

export function UnlimitedTariff({ package: pkg, onSelect, selected }: UnlimitedTariffProps) {
  if (!pkg) return null;

  return (
    <button
      type="button"
      className={[styles.wrap, selected ? styles.selected : ''].filter(Boolean).join(' ')}
      onClick={onSelect}
    >
      <span>
        <div className={styles.tunm}>{pkg.label}</div>
        <div className={styles.tuds}>{t.profile.unlimitedSub}</div>
      </span>
      <span style={{ textAlign: 'right' }}>
        <div className={styles.tuprc}>{formatPackagePrice(pkg.amount, pkg.currency)}</div>
      </span>
    </button>
  );
}
